import { render, staticRenderFns } from "./ui-radio.vue?vue&type=template&id=91fc302e&scoped=true&"
import script from "./ui-radio.vue?vue&type=script&lang=ts&"
export * from "./ui-radio.vue?vue&type=script&lang=ts&"
import style0 from "./ui-radio.vue?vue&type=style&index=0&id=91fc302e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fc302e",
  null
  
)

export default component.exports